import { getUserProfile } from 'app/selectors';
import { useAccess } from 'hooks/useAccess';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const NTC_ADMINISTRATOR_ROLE = 'NTCAdministrator';

export const useCatalogOtherAndLimitedAccess = () => {
    const { catalogs: catalogsRules } = useAccess();
    const profileInfo = useSelector(getUserProfile) as { roles?: string[] } | undefined;
    const isNtcAdministrator = Boolean(profileInfo?.roles?.includes(NTC_ADMINISTRATOR_ROLE));

    return useMemo(
        () => ({
            canCreate: isNtcAdministrator,
            canEdit: isNtcAdministrator,
            canDelete: isNtcAdministrator,
            canRead: Boolean(catalogsRules?.canRead),
        }),
        [catalogsRules?.canRead, isNtcAdministrator],
    );
};
